var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColourTintHalficon = function SvgColourTintHalficon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.904 15.719a5.904 5.904 0 0 1-4.972-9.088L6.737.69C7.032.231 7.516 0 8 0c.484 0 .968.23 1.263.691l3.805 5.94a5.904 5.904 0 0 1-4.972 9.088h-.192ZM8 1.5v12.719h.096a4.404 4.404 0 0 0 3.709-6.78L8 1.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgColourTintHalficon;